const atualizarHorimetroKMs = (state, horimetroKMs) => {
    state.horimetroKMs = horimetroKMs;
}

const atualizarHorimetroKM = (state, horimetroKM) => {
    state.horimetroKM = horimetroKM;
}

export default {
    atualizarHorimetroKMs,
    atualizarHorimetroKM
}